import { useMediaQuery } from "react-responsive"

export const useIsMobile = () => {
    return useMediaQuery({ query: "(max-width: 767px)" })
}

export const useIsTablet = () => useMediaQuery({ minWidth: 768, maxWidth: 991 })

export const APP_BAR_DESKTOP = 64; // adjust if your header height differs
export const TOP_PADDING_PX = 16;  // desired space under header
export const VIEWPORT_HEIGHT = `calc(100vh - ${APP_BAR_DESKTOP}px - ${TOP_PADDING_PX}px)`;
